import React from 'react'
import { faq } from '../../../content/site'

// FAQ hero, on the new design (Task 9). Same dark .hero-section treatment as About and
// Services (reuses .about-hero-inner's single-column grid override verbatim) so all three
// read as siblings, per the task brief. The old hero (src/pages/public/faq/hero.jsx before
// this task, af0b768) carried only a title - no eyebrow, no lead paragraph - so none is
// invented here; adding either would violate the "nothing invented" content rule.
const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero about-hero-inner -reading">
        <h1>{faq.hero.title}</h1>
      </div>
    </section>
  )
}

export default Hero
